<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onSave" :disabled="isDisabled" v-if="isSave">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" :disabled="isDisabled" v-if="isSubmit">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onIssue" v-if="isRelease">下发</el-button>
        <!-- <el-button size="mini" class="btn" type="primary" @click="onReject('Y')" v-if="(ms_Permission.indexOf('QSPI_QIP_INVOLVECQS')!== -1 && detailForm.isDcCodeAuth && detailForm.fscFeedbackStatus=='TO_BE_FSC_ISSUED') || (ms_roles.indexOf('QSPI_QIP_CQS') !== -1 && detailForm.isCategoryAuth && detailForm.fscFeedbackStatus=='TO_BE_CQS_ISSUED')">条件收货</el-button> -->
        <el-button size="mini" class="btn" type="primary" @click="onReject('Y')" v-if="isShowButton">条件收货</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReject('N')" v-if="isShowButton">拒收</el-button>
        <!-- <el-button size="mini" class="btn" type="primary" @click="onReject('N')" v-if="(ms_Permission.indexOf('QSPI_QIP_INVOLVECQS')!== -1 && detailForm.isDcCodeAuth && detailForm.fscFeedbackStatus=='TO_BE_FSC_ISSUED') || (ms_roles.indexOf('QSPI_QIP_CQS') !== -1&& detailForm.isCategoryAuth && detailForm.fscFeedbackStatus=='TO_BE_CQS_ISSUED')">拒收</el-button> -->
        <el-button size="mini" class="btn" type="primary" @click="onCqsConfirm" v-if="isAssistedDecision">邀请CQS协助判定</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onVerificationCompleted" v-if="isChecked">核实完成</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onNoObjection" v-if="isQues">无异议</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onObjection" v-if="isQues">有异议</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="120px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">Basic Information</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="评价月" prop="month">
                  <el-select v-model="detailForm.month" @change="monthChange" :disabled="isDisabled" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in monthOptions" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="QIP单据编号" prop="qipCode">
                  <el-input v-model="detailForm.qipCode" @input="detailForm.qipCode = detailForm.qipCode.toLocaleUpperCase()" :disabled="isDisabled" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商名称" prop="supplierName">
                  <el-input v-model="detailForm.supplierName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="产品名称" prop="eightBitCodeName">
                  <el-input v-model="detailForm.eightBitCodeName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="产品类别" prop="category2Name">
                  <el-input v-model="detailForm.category2Name" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="不合格原因" prop="causeOfNonconformity">
                  <ic-select :disabled="isDisabled" clearable table="TT_QSPI_QIP" field="CAUSE_OF_NONCONFORMITY" @change="causeOfNonconformityChange" placeholder="请选择" v-model="detailForm.causeOfNonconformity" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="风险等级" prop="riskGrade">
                  <ic-select :disabled="isDisabled" clearable table="TT_QSPI_QIP" field="RISK_GRADE" placeholder="请选择" v-model="detailForm.riskGrade" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问题产品数量" prop="quantity">
                  <el-input v-model="detailForm.quantity" :disabled="isDisabled" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="单位" prop="mcdBuyingUnit">
                  <ic-select disabled table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="detailForm.mcdBuyingUnit"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="责任方" prop="responsibleParty">
                  <ic-select :disabled="isDisabled" clearable table="TT_QSPI_QIP" field="RESPONSIBLE_PARTY" placeholder="请选择" v-model="detailForm.responsibleParty" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="承运商" prop="carrierCode">
                  <el-select v-model="detailForm.carrierCode" :disabled="isDisabled" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="item.supplierCode" v-for="item in carrierCodeOptions" :label="item.supplierName" :value="item.supplierCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="产品属性" prop="temperature">
                  <ic-select clearable table="COMMON" field="TEMPERATURE" disabled v-model="detailForm.temperature"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="供应商编号" prop="supplierCode">
                  <el-input v-model="detailForm.supplierCode" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="QIP日期" prop="qipDate">
                  <el-date-picker v-model="detailForm.qipDate" :disabled="isDisabled" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="产品生产日期" prop="productionDate">
                  <el-date-picker v-model="detailForm.productionDate" :disabled="isDisabled" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="产品编号" prop="eightBitCode">
                  <el-input v-model="detailForm.eightBitCode" readonly style="width: 100%;" v-if="!isDisabled">
                    <el-button slot="append" icon="el-icon-search" @click="showDetail"></el-button>
                  </el-input>
                  <el-input v-model="detailForm.eightBitCode" :disabled="isDisabled" v-else style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="发现环节" prop="discoveryLink">
                  <ic-select :disabled="isDisabled" clearable table="TT_QSPI_QIP" field="DISCOVERY_LINK" placeholder="请选择" v-model="detailForm.discoveryLink" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="处理方式" prop="processingMode">
                  <ic-select :disabled="isDisabled" clearable table="TT_QSPI_QIP" field="PROCESSING_MODE" placeholder="请选择" v-model="detailForm.processingMode" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="DC编号" prop="dcCode">
                  <el-select v-model="detailForm.dcCode" :disabled="isDisabled" clearable @change="dcCodeChange" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item, index) in dcCodeLists" :label="item.dcCode" :value="item.dcCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="订单编号" prop="orderNo">
                  <el-input v-model="detailForm.orderNo" :disabled="isDisabled" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="批准方" prop="approver">
                  <ic-select :disabled="isDisabled" clearable table="TT_QSPI_QIP" field="APPROVER" placeholder="请选择" v-model="detailForm.approver" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="CQS特批" prop="cqsSpecialApprover">
                  <ic-select :disabled="isDisabled" clearable table="TT_QSPI_QIP" field="CQS_SPECIAL_APPROVER" placeholder="请选择" v-model="detailForm.cqsSpecialApprover" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Facility名称" prop="facilityName">
                  <el-input v-model="detailForm.facilityName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="status">
                  <ic-select disabled table="TT_QSPI_QIP" field="STATUS" placeholder="请选择" v-model="detailForm.status" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="备注" prop="remarks">
                  <el-input v-model="detailForm.remarks" :disabled="isDisabled" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="ms_roles.indexOf('QSPI_QIP_OWNER') !== -1">
                <el-form-item label="QIP_Owner备注" prop="ownerRemarks">
                  <el-input v-model="detailForm.ownerRemarks" :disabled="isDisabled" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- QMS原始信息 -->
        <div class="within_box" v-if="isMcdFlag && detailForm.dataSource === 'QMS'">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">QMS原始信息</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="QIP报告属性" prop="qipReportAttributes">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="QIP_REPORT_ATTRIBUTES" placeholder="请选择" v-model="detailForm.qipReportAttributes" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="DC_QS处理方式" prop="qmsProcessingMode">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="PROCESSING_MODE" placeholder="请选择" v-model="detailForm.qmsProcessingMode" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="处理建议" prop="qipProcessingModeSuggestion">
                  <el-tooltip placement="top" :content="detailForm.qipProcessingModeSuggestion" :disabled="showTooltip">
                    <el-input v-model="detailForm.qipProcessingModeSuggestion" :disabled="true" @mouseover.native="inputOnMouseOver($event)" clearable style="width:100%"></el-input>
                  </el-tooltip>
                  <!-- <el-input v-model="detailForm.qipProcessingModeSuggestion" :disabled="true" clearable style="width:100%"></el-input> -->
                </el-form-item>
              </el-col>
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="不合格原因" prop="qmsCauseOfNonconformity">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" :isShowTooltip="true" field="CAUSE_OF_NONCONFORMITY" placeholder="请选择" v-model="detailForm.qmsCauseOfNonconformity" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="风险等级" prop="qmsRiskGrade">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="RISK_GRADE" placeholder="请选择" v-model="detailForm.qmsRiskGrade" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="责任方是否已确认" prop="responsibleConfirm" v-if="ms_emplFlag!=='SUP'">
                  <ic-select :disabled="isRelease ? false : true" clearable table="TT_QSPI_QIP" field="RESPONSIBLE_CONFIRM" placeholder="请选择" v-model="detailForm.responsibleConfirm" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="责任方" prop="qmsResponsibleParty">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="PROCESSING_MODE" placeholder="请选择" v-model="detailForm.qmsResponsibleParty" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="提供调查报告" prop="investigationReportsFlag">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="RESPONSIBLE_CONFIRM" placeholder="请选择" v-model="detailForm.investigationReportsFlag" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <!-- </el-row>
            <el-row :gutter="20"> -->
              <el-col :span="6">
                <el-form-item label="货品温度" prop="productTemperature">
                  <el-input v-model="detailForm.productTemperature" :disabled="true" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="问题产品数量" prop="qmsQuantity">
                  <el-input v-model="detailForm.qmsQuantity" :disabled="true" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="到货箱数" prop="arriveBox">
                  <el-input v-model="detailForm.arriveBox" :disabled="true" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="检测箱数" prop="detectionBox">
                  <el-input v-model="detailForm.detectionBox" :disabled="true" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!-- </el-row>
            <el-row :gutter="20"> -->
              <!-- *** -->
              <el-col :span="6">
                <el-form-item label="车厢连续温度是否合格" prop="vehicleTemperature">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="RESPONSIBLE_CONFIRM" placeholder="请选择" v-model="detailForm.vehicleTemperature" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="QIP情况描述" prop="qipDescription">
                  <el-input v-model="detailForm.qipDescription" :disabled="true" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 6 }" placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 处理方式判定 -->
        <div class="within_box" v-if="(isMcdFlag && detailForm.dataSource === 'QMS' && !(!detailForm.cqsProcessingMode && ms_roles.indexOf('QSPI_QIP_CQS') > -1)) || isShowButton">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">处理方式判定</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20" v-if="detailForm.fscProcessingMode || detailForm.fscFeedbackStatus != 'TO_BE_ISSUED'">
              <el-col :span="6">
                <el-form-item label="FSC处理方式" prop="fscProcessingMode">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="PROCESSING_MODE" placeholder="请选择" v-model="detailForm.fscProcessingMode" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="detailForm.fscProcessingMode || detailForm.fscFeedbackStatus != 'TO_BE_ISSUED'">
              <el-col :span="24">
                <el-form-item label="FSC处理意见" prop="fullFscProcessingModeComments">
                  <el-input v-model="detailForm.fullFscProcessingModeComments" :disabled="true" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 6 }" placeholder="请输入FSC处理意见"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="detailForm.cqsProcessingMode || detailForm.fscFeedbackStatus == 'TO_BE_CQS_ISSUED'">
              <el-col :span="6">
                <el-form-item label="CQS建议处理" prop="cqsProcessingMode">
                  <ic-select :disabled="true" clearable table="TT_QSPI_QIP" field="PROCESSING_MODE" placeholder="请选择" v-model="detailForm.cqsProcessingMode" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="detailForm.cqsProcessingMode || detailForm.fscFeedbackStatus == 'TO_BE_CQS_ISSUED'">
              <el-col :span="24">
                <el-form-item label="CQS处理意见" prop="cqsProcessingModeSuggestion">
                  <el-input v-model="detailForm.cqsProcessingModeSuggestion" :disabled="true" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 6 }" placeholder="请输入CQS处理意见"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 反馈信息 -->
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">反馈信息</p>
          </div>
          <div class="form_box">
            <table class="table-d">
              <tr>
                <td>反馈结果</td>
                <td>{{ detailForm.feedbackResults }}</td>
                <td>建议责任方</td>
                <td>{{ detailForm.proposeResponsiblePartyI18n }}</td>
                <td>反馈方</td>
                <td>{{ detailForm.feedbackParty }}</td>
              </tr>
              <tr>
                <td>核实截止时间</td>
                <td>{{ detailForm.closingDate }}</td>
                <td>理由</td>
                <td>{{ detailForm.reason }}</td>
              </tr>
            </table>
          </div>
        </div>
      </el-form>
      <div class="tab_box">
        <el-tabs type="border-card">
          <el-tab-pane label="附件">
            <el-row style="margin-bottom:5px" v-if="isShow">
              <el-upload ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
                <el-button slot="trigger" size="small" type="primary">上传</el-button>
              </el-upload>
            </el-row>
            <el-table ref="plxTable1" :data="tableData1" max-height="500" border highlight-current-row>
              <el-table-column align="center" label="操作" width="80" v-if="isShow">
                <template slot-scope="scope">
                  <el-button type="text" @click="onDel(scope.row.tmDocumentId, scope.$index, tableData1, scope.row)" v-if="ms_userId === scope.row.createBy">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="文件名称" prop="documentName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" @click="onDownload(scope.row, scope.$index)">{{ scope.row.documentName
                  }}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="上传人" prop="userName" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传时间" prop="createDate" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="图片">
            <el-upload ref="problemProductPhotoRef" :class="{ hide: disableEditor }" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP" :disabled="disableEditor" multiple list-type="picture-card" action="upload" :file-list="problemProductPhotoList">
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" style="height: 100%">
                <img width='100%' height='100%' :src="file.url" alt="">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handleProblemProductPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                    <i class="el-icon-download"></i>
                  </span>
                  <!-- <span v-if="!disableEditor" class="el-upload-list__item-delete" @click="problemProductPhotRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span> -->
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="problemProductDialogVisible" class="enlargePhoto">
              <img width="100%" :src="problemProductImageUrl" alt="">
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane label="操作日志">
            <el-table ref="plxTable2" :data="tableData2" max-height="500" border highlight-current-row>
              <el-table-column align="center" label="操作时间" prop="createDate" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="操作人" prop="operatorName" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="操作描述" prop="comments" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="产品名称选择" :visible.sync="dialogProVisible" width="80%" @close="onClosePro">
      <selMaterial v-if="dialogProVisible" @setSelPro="setSelPro"></selMaterial>
    </el-dialog>
    <el-dialog title="维护异议" :visible.sync="dialogObjectVisible" width="40%" @close="onCloseObject">
      <feedback-Dialog v-if="dialogObjectVisible" :userId="ms_userId" :id="ttQspiQipId" :form="form" @onCloseObject1="onCloseObject1" @onCloseObject="onCloseObject"></feedback-Dialog>
    </el-dialog>
    <!-- 条件收货和拒收弹框 -->
    <el-dialog :title="dialogTit === 'Y' ? '条件收货' : (this.dialogTit == 'N' ? '拒收' : '邀请CQS协助判定')" :visible.sync="dialogReVisable" width="50%">
      <div>
        <el-form :model="qmsForm" ref="qmsForm" label-width="100px">
          <el-row>
            <el-col>
              <el-form-item label="处理意见" prop="processingModeSuggestion">
                <el-input v-model="qmsForm.processingModeSuggestion" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="small" type="primary" @click="saveConfirm">保存</el-button>
          <el-button size="small" type="primary" @click="dialogReVisable = false">取消</el-button>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import QIPApi from "@/api/QIP/index";
import QBRApi from "@/api/QBR/index";
import DQMPApi from "@/api/DQMP/index";
import commonConstants from "@/constants/commonConstants";
import selMaterial from "./selMaterial.vue"
import feedbackDialog from "./feedbackDialog.vue"
export default {
  name: "QIPDetail",
  components: {
    IcSelect,
    selMaterial,
    feedbackDialog
  },
  data() {
    let validQipCode = (rule, value, callback) => {
      console.log('value', value);
      if (!value) {
        this.$my_message('请输入QIP单据编号', 'error')
        callback(new Error(' '));
      } else {
        if(value.length === 12||value.length === 13) {
          callback();
        } else {
          this.$my_message("QIP单据编号格式统一为：DC简称（2或3位）+QIP+YY+'MM'+三位流水码", 'error')
          callback(new Error(' '));
        }
      }
    };
    let validQuantity = (rule, value, callback) => {
      console.log('value', value);
      if (!value) {
        this.$my_message('请输入问题产品数量', 'error')
        callback(new Error(' '));
      } else {
        var reg = /^[1-9]\d*$/
        var reg1 = /^\d{1,10}$/
        if (!reg.test(value)) {
          this.$my_message('请输入正整数', 'error')
          callback(new Error(' '));
        } else {
          if (!reg1.test(value)) {
            this.$my_message('字段“问题产品数量”已超出数据库长度要求（长度：10），请删减.', 'error')
            callback(new Error(' '));
          } else {
            callback();
          }
        }
      }
    };
    let validOrderNo = (rule, value, callback) => {
      console.log('value', value);
      var reg = /^.{0,50}$/
      if (!reg.test(value)) {
        this.$my_message('字段“订单编号”已超出数据库长度要求（长度：50），请删减.', 'error')
        callback(new Error(' '));
      } else {
        callback();
      }
    };
    let validRemarks = (rule, value, callback) => {
      console.log('value', value);
      if ((this.detailForm.causeOfNonconformity === 'FAILEDREASON_17' || this.detailForm.responsibleParty === '其他' || this.detailForm.discoveryLink === 'OTHER') && !value) {
        this.$my_message('请输入备注', 'error')
        callback(new Error(' '));
      } else {
        callback();
      }
    };
    let validCarrierCode = (rule, value, callback) => {
      console.log('value', value);
      if (this.savetype !== 'saveOrSubmit' && this.detailForm.responsibleParty === "承运商" && !value) {
        this.$my_message('请选择承运商', 'error')
        callback(new Error(' '));
      } else {
        callback();
      }
    };
    return {
      dialogProVisible: false,
      dialogObjectVisible: false,
      isShow: true,
      isSave: true,//保存
      isSubmit: true,//提交
      isRelease: true,//下发
      isAssistedDecision: false, //邀请CQS协助判定
      isMcdFlag: false, // 是否显示qms信息和协助判定
      dialogTit: "", //条件收货和拒收标题
      dialogReVisable: false, //显示条件收货和拒收弹框
      isChecked: true,//核实完成
      isQues: true,//有无异议
      ttQspiQipId: null,
      ms_roles: null,
      ms_userId: null,
      supplierObj: null,
      problemProductPhotoList: [], // 图片集合
      problemProductImageUrl: "", // 图片地址
      problemProductDialogVisible: false, // 图片弹框
      disableEditor: true,
      savetype: "",
      ms_Permission: [],
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      form: null,
      qmsForm: {
        processingModeSuggestion: ""
      },
      rules: {
        month: [
          { required: true, message: '请选择评价月', trigger: 'change' },
        ],
        qipCode: [
          { required: true, validator: validQipCode, trigger: 'blur' },
        ],
        causeOfNonconformity: [
          { required: true, message: '请选择不合格原因', trigger: 'change' },
        ],
        quantity: [
          { required: true, validator: validQuantity, trigger: 'blur' },
        ],
        responsibleParty: [
          { required: true, message: '请选择责任方', trigger: 'change' },
        ],
        qipDate: [
          { required: true, message: '请选择QIP日期', trigger: 'change' },
        ],
        eightBitCode: [
          { required: true, message: '请输入产品编号', trigger: 'change' },
        ],
        discoveryLink: [
          { required: true, message: '请选择发现环节', trigger: 'change' },
        ],
        processingMode: [
          { required: true, message: '请选择处理方式', trigger: 'change' },
        ],
        dcCode: [
          { required: true, message: '请选择DC编号', trigger: 'change' },
        ],
        approver: [
          { required: true, message: '请选择批准方', trigger: 'change' },
        ],
        cqsSpecialApprover: [
          { required: true, message: '请选择允收期CQS特批', trigger: 'change' },
        ],
        riskGrade: [
          { required: true, message: '请选择风险等级', trigger: 'change' },
        ],
        orderNo: [
          { required: false, validator: validOrderNo, trigger: 'blur' },
        ],
        remarks: [
          { required: false, validator: validRemarks, trigger: 'blur' },
        ],
        carrierCode: [
          { required: false, validator: validCarrierCode, trigger: 'blur' },
        ],
      },
      detailForm: {},
      tableData1: [],
      tableData2: [],
      monthOptions: [],
      category2CodeOptions: [],
      carrierCodeOptions: [],
      dcCodeLists: [],
      fileList: [],
      showTooltip: true, // 处理建议是否可以悬浮展示
      ms_emplFlag: null
    }
  },
  // watch: {
  //   "detailForm.eightBitCode": {
  //     handler(newV, oldV) {
  //       console.log('newV', newV);
  //       if (newV) {
  //         if (this.detailForm.month) {
  //         }
  //       }
  //     },
  //     deep: true
  //   }
  // },
  computed: {
    uploadUrl() {
      return commonConstants.fileUploadUrl;
    },
    isShowButton() {
      let isReject = false;
      if ((this.ms_Permission.indexOf('QSPI_QIP_INVOLVECQS') !== -1 && this.detailForm.isDcCodeAuth && this.detailForm.fscFeedbackStatus == 'TO_BE_FSC_ISSUED') || (this.ms_roles.indexOf('QSPI_QIP_CQS') !== -1 && this.detailForm.isCategoryAuth && this.detailForm.fscFeedbackStatus == 'TO_BE_CQS_ISSUED')) {
        isReject = true
      }
      return isReject
    }
  },
  created() {
    this.ms_userId = JSON.parse(localStorage.getItem('ms_userId'))
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.supplierObj = JSON.parse(localStorage.getItem('supplierObj'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    //用户所属系统
    let emplFlag = localStorage.getItem('ms_emplFlag');
    this.ms_emplFlag = localStorage.getItem('ms_emplFlag')
    this.isMcdFlag = emplFlag === 'MCD' ? true : false;
    console.log('ms_roles', this.ms_roles);
    console.log('ms_Permission', this.ms_Permission);
    console.log('ms_userId', this.ms_userId);
    console.log('supplierObj', this.supplierObj);
    if (this.$route.query.from === 'edit') {
      this.ttQspiQipId = this.$route.query.ttQspiQipId
      this.getDetailInfo()
      this.getFileLists(this.ttQspiQipId)
      this.getImageLists(this.ttQspiQipId)
    } else {
      this.getPrimaryKey()
    }
  },
  mounted() {
    this.getMonth();
    this.getCarrier();
    this.getCategory();
    this.getQspiDcList()
  },
  methods: {
    causeOfNonconformityChange(val) {
      console.log('val', val);
      if (val === 'FAILEDREASON_01' || val === 'FAILEDREASON_02' || val === 'FAILEDREASON_03' || val === 'FAILEDREASON_04') {
        this.detailForm.riskGrade = 'A'
      } else if (val === 'FAILEDREASON_05' || val === 'FAILEDREASON_06' || val === 'FAILEDREASON_07' || val === 'FAILEDREASON_08' || val === 'FAILEDREASON_09' || val === 'FAILEDREASON_10' || val === 'FAILEDREASON_11' || val === 'FAILEDREASON_12' || val === 'FAILEDREASON_13f') {
        this.detailForm.riskGrade = 'B'
      } else if (val === 'FAILEDREASON_14' || val === 'FAILEDREASON_15' || val === 'FAILEDREASON_16' || val === 'FAILEDREASON_17' || val === 'FAILEDREASON_18') {
        this.detailForm.riskGrade = 'C'
      }
    },
    getPrimaryKey() {
      QIPApi.getPrimaryKey().then(res => {
        console.log('4543', res);
        this.ttQspiQipId = res
        this.detailForm.ttQspiQipId = res
        this.setButtonPermission()
      });
    },
    getDetailInfo() {
      QIPApi.findListPage({
        ttQspiQipId: this.ttQspiQipId
      }).then(res => {
        console.log('535232', res);
        this.detailForm = res.data.records[0]
        if (res.data.records.length > 0) {
          this.tableData2 = res.data.records[0].workFlowLogList
        }
        this.setButtonPermission()
      });
    },
    // 鼠标悬浮在处理建议上时，判断文字是否超出设置宽度
    inputOnMouseOver(event) {
      let target = event.target
      this.showTooltip = target.offsetWidth < target.scrollWidth ? false : true;
    },
    setButtonPermission() {
      // 20220506会议修改 去掉角色控制
      if ((this.detailForm.status === 'DRAFT' || !this.detailForm.status) && this.ms_Permission.indexOf('QSPI_QIP_SAVE') !== -1) {
        this.isSave = true
      } else {
        this.isSave = false
      }
      if ((this.detailForm.status === 'DRAFT' || !this.detailForm.status) && this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') !== -1) {
        this.isSubmit = true
      } else {
        this.isSubmit = false
      }
      if (this.ms_roles.indexOf('QSPI_QIP_OWNER') !== -1 && this.detailForm.status === 'SUBMITTED' && this.detailForm.fscFeedbackStatus === 'TO_BE_ISSUED' && this.ms_Permission.indexOf('QSPI_QIP_RELEASE') !== -1) {
        this.isRelease = true
      } else {
        this.isRelease = false
      }
      if (this.ms_roles.indexOf('QSPI_QIP_OWNER') !== -1 && (this.detailForm.status === 'TIMED_OUT' || this.detailForm.status === 'OBJECTION_HAVE_BEEN_FEEDBACK') && this.ms_Permission.indexOf('QSPI_QIP_CHECKED') !== -1) {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
      if (this.detailForm.status === 'CHECK' && (this.ms_Permission.indexOf('QSPI_QIP_CARRIER') !== -1 || this.ms_Permission.indexOf('QSPI_QIP_SUPPLIER') !== -1)) {
        this.isQues = true
      } else {
        this.isQues = false
      }
      console.log('detailForm==', this.detailForm);
      // 是否显示邀请CQS协助判定按钮
      if (this.detailForm.fscFeedbackStatus === 'TO_BE_FSC_ISSUED' && !this.detailForm.cqsProcessingMode && this.ms_Permission.indexOf('QSPI_QIP_INVOLVECQS') !== -1 && this.detailForm.isDcCodeAuth) {
        this.isAssistedDecision = true;
      } else {
        this.isAssistedDecision = false;
      }
      // 供应商/承运商并且没有提交权限不可编辑
      // 核实/作废状态不可编辑
      // 草稿状态时,创建人不是当前用户不可编辑
      // 如果非草稿状态并且有提交权限不可编辑
      if (this.$route.query.from === 'edit' &&
        (
          (this.ms_Permission.indexOf('QSPI_QIP_SUPPLIER') !== -1 && this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') === -1) ||
          (this.ms_Permission.indexOf('QSPI_QIP_CARRIER') !== -1 && this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') === -1) ||
          (this.ms_Permission.indexOf('QSPI_QIP_CONRECP') !== -1 && this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') === -1) ||
          this.detailForm.status === 'CHECK' || this.detailForm.status === 'CANCEL' ||
          (this.detailForm.status !== 'DRAFT' && this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') !== -1) ||
          (this.detailForm.status === 'DRAFT' && this.detailForm.createBy !== this.ms_userId) ||
          (this.detailForm.fscFeedbackStatus !== 'TO_BE_ISSUED')
        )
      ) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
      // (1)权限为QSPI_QIP_SUBMIT并且状态是草稿 / 新增时, 可上传
      // (2)权限为QSPI_QIP_RELEASE或者QSPI_QIP_CHECKED, 并且状态是已提交 / 已反馈 / 已超时, 可上传
      // (3)权限为QSPI_QIP_SUPPLIER或者QSPI_QIP_CARRIER, 并且状态是核实中, 可上传
      if (this.ms_Permission.indexOf('QSPI_QIP_SUBMIT') !== -1 && (this.detailForm.status === 'DRAFT' || !this.detailForm.status)) {
        this.isShow = true
      } else if ((this.ms_Permission.indexOf('QSPI_QIP_RELEASE') !== -1 || this.ms_Permission.indexOf('QSPI_QIP_CHECKED') !== -1) && (this.detailForm.status === 'SUBMITTED' || this.detailForm.status === 'OBJECTION_HAVE_BEEN_FEEDBACK' || this.detailForm.status === 'TIMED_OUT')) {
        this.isShow = true
      } else if ((this.ms_Permission.indexOf('QSPI_QIP_SUPPLIER') !== -1 || this.ms_Permission.indexOf('QSPI_QIP_CARRIER') !== -1) && this.detailForm.status === 'CHECK') {
        this.isShow = true
      } else {
        this.isShow = false
      }
      console.log('isSave', this.isSave);
      console.log('isSubmit', this.isSubmit);
      console.log('isRelease', this.isRelease);
      console.log('isChecked', this.isChecked);
      console.log('isQues', this.isQues);
      console.log('isDisabled', this.isDisabled);
      console.log('isShow', this.isShow);
    },
    getMonth() {
      DQMPApi.getMonth().then(res => {
        this.monthOptions = res
      })
    },
    getCarrier() {
      QIPApi.getCarrier({
        type: "CARRIER",
        pageSize: -1
      }).then(res => {
        console.log('res', res);
        this.carrierCodeOptions = res.resultData
      })
    },
    getCategory() {
      QIPApi.getCategory({
        categoryLevel: 2
      }).then(res => {
        console.log('res', res);
        this.category2CodeOptions = res.data
      })
    },
    getQspiDcList() {
      QIPApi.getQspiDcList({
        status: "ACTIVE",
        pageSize: -1,
      }).then(res => {
        console.log('res', res);
        this.dcCodeLists = res.resultData
      })
    },
    showDetail() {
      this.dialogProVisible = true
    },
    setSelPro(val) {
      console.log('val', val);
      var obj = JSON.parse(val)
      this.$set(this.detailForm, 'supperSupplierId', obj.supperSupplierId)
      this.$set(this.detailForm, 'supplierCode', obj.supplierCode)
      this.$set(this.detailForm, 'supplierName', obj.supplierName)
      this.$set(this.detailForm, 'facilityCode', obj.facilityCode)
      this.$set(this.detailForm, 'facilityName', obj.facilityName)
      this.$set(this.detailForm, 'eightBitCodeName', obj.eightBitCodeName)
      this.$set(this.detailForm, 'eightBitCode', obj.eightBitCode)
      this.$set(this.detailForm, 'category2Name', obj.categoryLevel2Name)
      this.$set(this.detailForm, 'category2Code', obj.categoryLevel2Code)
      this.$set(this.detailForm, 'mcdBuyingUnit', obj.mcdBuyingUnit)
      this.$set(this.detailForm, 'temperature', obj.temperature)
      console.log('eightBitCode', this.detailForm.eightBitCode);
      console.log('month', this.detailForm.month);
      console.log('dcCode', this.detailForm.dcCode);
      if (this.detailForm.eightBitCode && this.detailForm.month && this.detailForm.dcCode) {
        console.log('88888');
        this.getRelatedCarrier(this.detailForm.eightBitCode, this.detailForm.month, this.detailForm.dcCode)
      }
      this.dialogProVisible = false
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$my_message(this.$t('prompt.imageFileSize'), 'error');
      }
      return isLt50M;
    },
    uploadConfirm(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      //调用成功后调用后台方法进行文件关系维护
      fileService.fileUpload(formData).then(res => {
        let attachment = {};
        attachment.documents = res.data[0];
        if ('jpg、png、jpeg、gif、bmp'.indexOf(attachment.documents.fileSuffix) !== -1) {
          attachment.seq = "2";
        } else {
          attachment.seq = "1";
        }
        attachment.tsRecId = this.ttQspiQipId;
        attachment.tsReckindId = "QSPI_QIP_FILE";
        fileService.saveFile(attachment).then(saveRes => {
          _this.getFileLists(this.ttQspiQipId);
          _this.getImageLists(this.ttQspiQipId)
        });
      }).catch(error => {
        //文件上传失败
        _this.$message({
          type: "error",
          message: _this.$t("common.fileUploadFailed")
        });
      });
    },
    getFileLists(ttQspiQipId) {
      QBRApi.getFileLists({
        seq: '1',
        tsReckindId: "QSPI_QIP_FILE",
        tsRecId: ttQspiQipId
      }).then(res => {
        this.tableData1 = res
      });
    },
    getImageLists(ttQspiQipId) {
      QBRApi.getFileLists({
        seq: '2',
        tsReckindId: "QSPI_QIP_FILE",
        tsRecId: ttQspiQipId
      }).then(res => {
        console.log('resImage==', res);
        if (res && res.length > 0) {
          var temp = res.map(function (item) {
            let obj = {
              name: item["documentName"],
              url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
              documentName: item["documentName"],
              downloadType: item["downloadType"],
              tmDocumentId: item["tmDocumentId"]
            };
            return obj;
          });
          this.problemProductPhotoList = temp
        }
        // this.tableData1 = res
      });
    },
    // 点击图片查看
    handleProblemProductPreview(file) {
      this.problemProductImageUrl = file.url;
      this.problemProductDialogVisible = true;
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    onDel(tmDocumentId, index, files, row) {
      var ms_userId = localStorage.getItem('ms_userId')
      if (tmDocumentId) {
        if (ms_userId == row.createBy) {
          fileService.deleteFile(tmDocumentId).then((res) => {
            if (res.code === '200') {
              files.splice(index, 1);
            }
          })
        } else {
          this.$message.error('')
        }
      } else {
        //还没保存
        files.splice(index, 1);
      }
    },
    onDownload(row, index) {
      fileService.downloadFile(row).then((res) => { })
    },
    monthChange(val) {
      if (val && this.detailForm.eightBitCode && this.detailForm.dcCode) {
        this.getRelatedCarrier(this.detailForm.eightBitCode, val, this.detailForm.dcCode)
      }
    },
    getRelatedCarrier(eightBitCode, month, dcCode) {
      QIPApi.getRelatedCarrier(eightBitCode, month, dcCode).then(res => {
        console.log('根据产品编号、月份获取默认承认商', res);
        if (res) {
          this.$set(this.detailForm, 'carrierCode', res)
          console.log('4311', this.detailForm.carrierCode);
        }
      })
    },
    onSave() {
      this.savetype = 'saveOrSubmit'
      this.sendReq('SAVE', '保存成功')
    },
    onSubmit() {
      this.savetype = 'saveOrSubmit'
      this.sendReq('SUBMIT', '提交成功')
    },
    onIssue() {
      this.savetype = ''
      this.sendReq('ISSUE', '下发成功')
    },
    onVerificationCompleted() {
      this.savetype = ''
      this.sendReq('COMPLETE', '操作成功')
    },
    onNoObjection() {
      if (this.supplierObj.supperSupplierId !== this.detailForm.supperSupplierId) {
        this.$message.warning("操作无权限，仅可以反馈承运商为自己的数据")
        return false
      }
      this.savetype = ''
      this.sendReq('NO_OBJECTION', '操作成功')
    },
    onObjection() {
      if (this.supplierObj.supperSupplierId !== this.detailForm.supperSupplierId) {
        this.$message.warning("操作无权限，仅可以反馈承运商为自己的数据")
        return false
      }
      this.savetype = ''
      this.dialogObjectVisible = true
      this.form = JSON.stringify(this.detailForm)
    },
    sendReq(type, msg) {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          this.$set(this.detailForm, 'type', type)
          QIPApi.updateQip(this.detailForm).then(res => {
            console.log('res213131', res);
            if (res.code === '200') {
              this.$message.success(msg)
              if (type !== 'SAVE') {
                this.$router.push('/qspiQIP')
              } else {
                this.ttQspiQipId = res.data.data
                this.getDetailInfo()
              }
            }
          })
        }
      })
    },
    // 条件收货
    // 拒收
    onReject(val) {
      this.dialogTit = val;
      this.dialogReVisable = true;
      this.qmsForm = {
        processingModeSuggestion: ""
      }
    },
    saveConfirm() {
      if (this.dialogTit === 'Y') {
        this.confirmFcReq('PART_REJECT', "操作成功")
      } else if (this.dialogTit === 'N') {
        this.confirmFcReq('REJECT', '操作成功')
      } else {
        this.confirmFcReq('CQSISSUED', "操作成功")
      }
    },
    // 邀请cqs判定
    onCqsConfirm() {
      this.dialogTit = "CQS"
      this.dialogReVisable = true;
      this.qmsForm = {
        processingModeSuggestion: ""
      }
    },
    confirmFcReq(type, msg) {
      let params = {
        ttQspiQipId: this.detailForm.ttQspiQipId,
        qipCode: this.detailForm.qipCode,
        processingModeSuggestion: this.qmsForm.processingModeSuggestion,
        type: type,
      }
      QIPApi.updateQip(params).then(res => {
        if (res.code === '200') {
          this.$message.success(msg)
          this.ttQspiQipId = res.data.data
          this.dialogReVisable = false;
          this.getDetailInfo()
        }
      })
    },
    dcCodeChange(val) {
      if (val && this.detailForm.eightBitCode && this.detailForm.month) {
        this.getRelatedCarrier(this.detailForm.eightBitCode, this.detailForm.month, val)
      }
      this.dcCodeLists.forEach(ele => {
        if (ele.dcCode == val) {
          this.$set(this.detailForm, 'dcName', ele.dcName)
        }
      })
    },
    onClosePro() {
      this.dialogProVisible = false
    },
    onCloseObject() {
      this.dialogObjectVisible = false
      this.getDetailInfo()
      this.getFileLists(this.ttQspiQipId)
    },
    onCloseObject1() {
      this.dialogObjectVisible = false
      this.$router.push('/qspiQIP')
    },
    routerBack() {
      // this.$router.go(-1)
      this.$router.push('/qspiQIP')
    },
  },
}
</script>

<style lang="scss">
.hide .el-upload--picture-card {
  display: none;
}
</style>